import { TRANSLATIONS_URL } from 'src/constants';

export const translationsUrl = () => {
  return TRANSLATIONS_URL.production;
};
